import { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import { useAuth } from "../../context/connectionContext";
import BalanceDialog from "./BalanceDialog";
import { useAccountBalances } from "../../context/balanceContext";
import { WIKEY_STORE_URL } from "../../utils/constants";

const BalanceButton = () => {
  const { account } = useAuth();
  const { displayTotalOST } = useAccountBalances();
  const [open, setOpen] = useState<boolean>(false);

  const link = `${WIKEY_STORE_URL}${account}&quantity=2&returnUrl=${window.location.origin}`;

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        variant="outlined"
        onClick={() => setOpen(true)}
        color="primary"
        sx={{
          minWidth: "auto",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            color: "primary.main",
            borderRadius: "50%",
            width: 24,
            height: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="button">{displayTotalOST}</Typography>
        </Box>
        <Typography variant="button">OST</Typography>
      </Button>
      <BalanceDialog open={open} handleClose={handleClose} link={link} />
    </>
  );
};

export default BalanceButton;
